import { render } from "./PlanSettingsCard.vue?vue&type=template&id=b75496d2&scoped=true"
import script from "./PlanSettingsCard.vue?vue&type=script&lang=js"
export * from "./PlanSettingsCard.vue?vue&type=script&lang=js"

import "./PlanSettingsCard.vue?vue&type=style&index=0&id=b75496d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b75496d2"]])

export default __exports__